import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const useAssetsToLendSectionStyle = createUseStyles({
    totalSupplyWrapper: {
        width: '25%',
        fontWeight: '500 !important',
    },
    claimReward: {
        textAlign: 'left !important',
        width: '100% !important',
        paddingLeft: '20px',
    },
    buttons: {
        width: '10%',
    },
    asset: {
        width: 250,
    },
    rewardText: {
        fontSize: fontSize.sm,
        color: color.content.secondary,
    },
    rewardPercent: {
        fontSize: fontSize.sm,
        color: color.content.primary,
    },
    tooltip: {
        padding: `${spacing['04']}`,
    },
    title: {
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: fontSize.md,
        marginBottom: spacing['03'],
    },
    reward: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 30,
    },
    spin: {
        textAlign: 'center',
        height: 50,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: spacing['07'],
        padding: `0 ${spacing['06']} ${spacing['06']} 0`,
    },
    text: {
        display: 'flex',
        alignItems: 'center',
        color: color.content.secondary,
        fontSize: fontSize.md,
    },
    poolBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
});
